module.exports = __webpack_public_path__ + "img/google-circle.441efb7b.svg";